import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Navbar from './components/Navbar';
import Footer from './components/Footer';
import Home from './pages/Home';
import About from './pages/About';
import History from './pages/History';
import MissionVision from './pages/MissionVision';
import WhyChooseUs from './pages/WhyChooseUs';
import Services from './pages/Services';
import CourtRental from './pages/CourtRental';
import Training from './pages/Training';
import Membership from './pages/Membership';
import Staff from './pages/Staff';
import Testimonials from './pages/Testimonials';
import Blog from './pages/Blog';
import BlogPost from './pages/BlogPost';
import Events from './pages/Events';
import Contact from './pages/Contact';
import ProfessionalBadmintonCoaching from './pages/ProfessionalBadmintonCoaching'
import TrainingPrograms from './pages/TrainingPrograms'
import IntermediateAdvancedTrainingProgram from './pages/IntermediateAdvancedTrainingProgram'
import YouthDevelopmentProgram from './pages/YouthDevelopmentProgram'
import FitnessConditioningTraining from './pages/FitnessConditioningTraining'
import MatchPracticeTournamentPreparation from './pages/MatchPracticeTournamentPreparation'
import PersonalCoachingSkillDevelopment from './pages/PersonalCoachingSkillDevelopment'
import RecreationalFitnessBadminton from './pages/RecreationalFitnessBadminton'
import Tournaments from './pages/tournaments'
import Equipmentshop from './pages/EquipmentShop'
import PrivateCoaching from './pages/PrivateCoaching'
import BeginnerTrainingProgram from './pages/BeginnerTrainingProgram'
import AdvancedCompetitiveTrainingProgram from './pages/AdvancedCompetitiveTrainingProgram'
import PersonalizedTrainingProgram from './pages/PersonalizedTrainingProgram'
import FitnessConditioningProgram from './pages/FitnessConditioningProgram'
import RecreationalTrainingProgram from './pages/RecreationalTrainingProgram'
import './App.css';

function App() {
  return (
    <div className="App">
      <Navbar />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/about" element={<About />} />
          <Route path="/history" element={<History />} />
          <Route path="/mission-vision" element={<MissionVision />} />
          <Route path="/why-choose-us" element={<WhyChooseUs />} />
          <Route path="/services" element={<Services />} />
          <Route path="/court-rental" element={<CourtRental />} />
          <Route path="/training" element={<Training />} />
          <Route path="/membership" element={<Membership />} />
          <Route path="/staff" element={<Staff />} />
          <Route path="/testimonials" element={<Testimonials />} />
          <Route path="/blog" element={<Blog />} />
          <Route path="/blog/:id" element={<BlogPost />} />
          <Route path="/events" element={<Events />} />
          <Route path="/contact" element={<Contact />} />
          <Route path="/Professional-Badminton-Coaching" element={<ProfessionalBadmintonCoaching />} />
          <Route path="/Training-Programs" element={<TrainingPrograms />} />
          <Route path="/Intermediate-Advanced-Training-Program" element={<IntermediateAdvancedTrainingProgram />} />
          <Route path="/Youth-Development-Program" element={<YouthDevelopmentProgram />} />
          <Route path="/Fitness-Conditioning-Training" element={<FitnessConditioningTraining />} />
          <Route path="/Match-Practice-Tournament-Preparation" element={<MatchPracticeTournamentPreparation />} />
          <Route path="/Personal-Coaching-Skill-Development" element={<PersonalCoachingSkillDevelopment />} />
          <Route path='/Recreational-Fitness-Badminton' element={<RecreationalFitnessBadminton />} />
          <Route path='/Tournaments' element={<Tournaments />} />
          <Route path='/Equipment-Shop' element={<Equipmentshop />} />
          <Route path='/Private-Coaching' element={<PrivateCoaching />} />
          <Route path='/Beginner-Training-Program' element={<BeginnerTrainingProgram />} />
          <Route path='/Advanced-Competitive-Training-Program' element={<AdvancedCompetitiveTrainingProgram />} />
          <Route path='/Personalized-Training-Program' element={<PersonalizedTrainingProgram />} />
          <Route path='/Fitness-Conditioning-Program' element={<FitnessConditioningProgram />} />
          <Route path='/Recreational-Training-Program' element={<RecreationalTrainingProgram />} />
        </Routes>
      </main>
      <Footer />
    </div>
  );
}

export default App;
